import sendFormImgMobile from '@/Assets/images/hero/mobile-send-form.png';
import sendFormImg from '@/Assets/images/hero/desktop-send-form.png';
import mainPageHeroMobile from '@/Assets/images/MainPageHeroMobile.png';
import mainPageHero from '@/Assets/images/mainPageHero.png';
import { Image } from '@/components/Image';
import { ROUTES } from '@/constants/routes.constants';
import { AnimatePresence, motion } from 'framer-motion';
import { useCallback, useEffect, useState } from 'react';

import { useWindowSize } from 'usehooks-ts';
import { HeroBg } from './HeroBg';
import './styles.css';

import { ModeSwitch } from '../ModeSwitch/ModeSwitch';
import { ArrowRight } from '@/Assets/Icons/ArrowRight';
import { ArrowElbowDownLeft } from '@/Assets/Icons/ArrowElbowDownLeft';
import SlotMachineText from './SlotMachineText';

export type HeroMode = 'bridge' | 'chatbot';

export function MainHero() {
  const { width } = useWindowSize();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [mode, setMode] = useState<HeroMode>('bridge');

  const [animationStage, setAnimationStage] = useState<
    'initial' | 'orbit' | 'spinning'
  >('initial');

  const startRedirect = useCallback(() => {
    if (animationStage === 'initial') {
      setIsRedirecting(true);
      setAnimationStage('orbit');
      setTimeout(
        () =>
          (window.location.href =
            mode === 'bridge' ? ROUTES.SEND_PAGE : ROUTES.CHATBOT),
        3500
      );
    }
  }, [animationStage, mode]);

  /*   useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && mode === 'chatbot') startRedirect();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [mode, startRedirect]); */

  return (
    <div className="main-page--hero">
      <HeroBg
        animationStage={animationStage}
        setAnimationStage={setAnimationStage}
      />
      <div className="main-page--hero--bg-container">
        <Image
          withSmoothLoading
          src={width <= 768 ? mainPageHeroMobile : mainPageHero}
          alt=""
        />
      </div>

      <AnimatePresence>
        {!isRedirecting && (
          <motion.div
            className="main-page--hero-heading-container"
            exit={{ opacity: 0 }}
          >
            <motion.h1
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.3 }}
              className="main-page--hero-heading"
            >
              Multichain made easy
              <br />
              <div className="d-flex align-items-center">
                All chains, single
                <SlotMachineText text={mode === 'bridge' ? 'app' : 'ai'} />
              </div>
            </motion.h1>
            <ModeSwitch mode={mode} setMode={setMode} />
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {!isRedirecting && (
          <motion.div
            className="main-page--hero-mode-content"
            exit={{ opacity: 0 }}
          >
            <AnimatePresence mode="wait">
              {mode === 'bridge' && (
                <motion.div
                  key="bridge"
                  className="bridge-content-container"
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="bridge-content-title">
                    <span>
                      <ArrowRight style={{ transform: 'rotate(90deg)' }} />
                    </span>
                    Enter bridging amount
                  </div>
                  <Image
                    width={596}
                    withSmoothLoading
                    src={width <= 768 ? sendFormImgMobile : sendFormImg}
                    alt=""
                    onClick={startRedirect}
                  />
                </motion.div>
              )}
              {mode === 'chatbot' && (
                <motion.div
                  className="chatbot-content-container"
                  key="chatbot"
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  {width > 768 && (
                    <div className="d-flex text-white fs-6 fw-bold bold justify-content-center align-items-center">
                      <span
                        className="main-page--hero-mode-content-action-icon"
                        style={{ marginRight: '12px' }}
                      >
                        <ArrowElbowDownLeft />
                      </span>
                      press Enter to ask RetroGPT
                    </div>
                  )}
                  <div
                    className="d-flex chatbot-content-input"
                    //onClick={startRedirect}
                  >
                    <motion.span
                      initial={{ opacity: 0.25 }}
                      animate={{ opacity: 1 }}
                      transition={{
                        duration: 0.5,
                        repeat: Infinity,
                        repeatType: 'mirror',
                      }}
                      className="text-white"
                    >
                      |
                    </motion.span>
                    <span>coming soon</span>
                  </div>

                  <div className="chatbot-suggestions-container">
                    <div className="chatbot-suggestion">
                      What is Eclipse Network?
                    </div>
                    <div className="chatbot-suggestion">
                      When is Linea Airdrop?
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        )}
      </AnimatePresence>
      {isRedirecting && (
        <span className="redirect-text fw-bold text-white bold fs-6">
          You are being redirected...
        </span>
      )}
    </div>
  );
}
